import React from 'react';
import { AddIconWoPadding, CustomerNotesIcon, IdentityIcon } from 'assets/icons';
import { CustomerDetails } from '../invoices.model';

interface CustomerMoreDetailsWidgetProps {
  customerData: CustomerDetails;
  openEditCustomerModal: () => void;
  isEditCustomerAllowed: boolean;
}

const CustomerMoreDetailsWidget: React.FC<CustomerMoreDetailsWidgetProps> = ({
  customerData,
  openEditCustomerModal,
  isEditCustomerAllowed
}) => {
  const moreDetails = [
    {
      id: 'customer-sidepanel-customer-note',
      title: 'Notes',
      data: customerData?.note,
      buttonText: 'Add customer note',
      onClick: openEditCustomerModal,
      icon: <CustomerNotesIcon className="shrink-0" />
    },
    {
      id: 'customer-sidepanel-customer-reference-id',
      title: 'Customer reference ID',
      data: customerData?.referenceNumber,
      buttonText: 'Add reference ID',
      onClick: openEditCustomerModal,
      icon: <IdentityIcon className="shrink-0" />
    }
  ];

  return customerData ? (
    <div className="mx-4 rounded-md border border-border px-4 py-3">
      <div className="mb-3 text-sbase font-bold leading-[18px] tracking-[-0.3px] text-primaryText">More Details</div>
      <div className="flex flex-col gap-3">
        {moreDetails.map(detail => (
          <div
            className="border-b border-highlightGray pb-3 last:border-b-0 last:pb-0 only:border-b-0 only:pb-0"
            key={detail.id}>
            <div className="flex items-center gap-4">
              {detail.icon}
              <div className="flex flex-col gap-1">
                <div className="text-px13 leading-[17px] text-accentText">{detail.title}</div>
                {detail.data ? (
                  <div className="break-all text-sbase font-semibold leading-[18px] tracking-[-0.3px] text-primaryText">
                    {detail.data}
                  </div>
                ) : (
                  <button
                    className={`flex items-center gap-1 text-sbase font-semibold
                              leading-[18px] tracking-[-0.3px] text-secondary
                              ${isEditCustomerAllowed ? 'opacity-100' : 'opacity-50'}`}
                    disabled={!isEditCustomerAllowed}
                    onClick={detail.onClick}>
                    <AddIconWoPadding className="mt-0.5" />
                    {detail.buttonText}
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default CustomerMoreDetailsWidget;
